/* eslint-disable import/no-extraneous-dependencies */

import moment from 'moment';
import { returnBaggageType } from '../util';
import ParcelModel from '../../models/parcel';
import { BaggageType } from '../../context/AppContext';
import { getDeliveryStatusName } from 'components/ParcelComponent/utils';

type parcelResponseModel = {
  addressFrom: any;
  addressTo: any;
  parcelTypes: Array<string>;
  clientAvatarUrl: string;
  clientId: string;
  createdOnTS: string;
  dealType: string;
  dateTS: string;
  firstName: string;
  fullUserName: string;
  id: number;
  lastModified: string;
  offerId: string;
  parcelDescription: string;
  price: number;
  phone: string;
  lastName: string;
  middleName: string;
  userName: string;
  isActual: boolean;
  isPremium: boolean;
  fromPlaceId: string;
  toPlaceId: string;
  deliveryStatus: string;
  parcelTitle: string;
  currency: string;
  sender: any;
  recommendedPriceStatus: string;
  canDelete: string;
};

const createParcelFromRowData = (
  responseItem: parcelResponseModel,
  baggages: Array<BaggageType>,
  t:any
): ParcelModel =>
  new ParcelModel({
    parcelTitle: responseItem.parcelTitle,
    createdOn: moment(responseItem.createdOnTS).format('DD.MM.YYYY HH:mm').toString(),
    date: moment(responseItem?.dateTS).format('DD.MM.YYYY HH:mm').toString(),
    id: responseItem.id,
    addressFrom: responseItem.addressFrom?.city,
    addressTo: responseItem.addressTo?.city,
    fio: `${responseItem?.sender?.lastName??''} ${responseItem?.sender?.firstName??''} ${responseItem?.sender?.middleName??''}`.trim() || '-',
    phoneNumber: responseItem?.sender?.phone,
    baggageTypes: responseItem?.parcelTypes?.map((item: string, index: number) =>
      baggages ? returnBaggageType(item, baggages, index === 0) : item
    ),
    parcelSum: responseItem?.price && responseItem?.currency && `${responseItem?.price} ${responseItem.currency}`,
    dealType: responseItem?.dealType,
    isActual: responseItem?.isActual,
    isPremium: responseItem?.isPremium,
    fromPlaceId: responseItem?.fromPlaceId,
    toPlaceId: responseItem?.toPlaceId,
    deliveryStatus: getDeliveryStatusName(responseItem?.deliveryStatus, t),
    recommendedPriceStatus: responseItem?.recommendedPriceStatus,
    canDelete: responseItem?.canDelete
  });

export const createParcelsListFromRowData = (
  response: Array<parcelResponseModel>,
  baggages: Array<BaggageType>,
  t: any
): Array<ParcelModel> =>
  response.map((item: parcelResponseModel) => createParcelFromRowData(item, baggages, t));

export const createSortedParcelsListFromRowData = (
  response: Array<parcelResponseModel>,
  baggages: Array<BaggageType>,
  t:any
): Array<ParcelModel> =>
  response
    .sort((a, b) => {
      const x = moment(a.createdOnTS);
      const y = moment(b.createdOnTS);
      return y.diff(x);
    })
    .map((item: parcelResponseModel) => createParcelFromRowData(item, baggages, t))
    ;

export default createSortedParcelsListFromRowData;
